  // Create the observer
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const $button = $('.product__submit__buttons');
        const $interactObserver = $('#interact-observer'); // Select the #interact-observer element

        // Calculate the height of .product__submit__buttons
        const buttonHeight = $button.outerHeight(); // Use outerHeight to include padding/borders

        // Clear the existing timeout if it's already set
        if (entry.isIntersecting) {
          setTimeout(() => {
            // Remove the classes after a delay when the element is back in the viewport
            $button.removeClass('slide-in lma_btn_submit');
            $interactObserver.css('height', ''); // Reset height when in viewport
          }, 1); // Adjust this delay as needed (currently 30ms)
        } else {
          setTimeout(() => {
            // Add the classes after a delay when the element is not in the viewport
            $button.addClass('slide-in lma_btn_submit');
            $interactObserver.css('height', buttonHeight + 'px'); // Set height to match button height when not in viewport
          }, 300); // Adjust this delay as needed (currently 300ms)
        }
      });
    },
    {
      root: null, // Default viewport
      threshold: [0.1, 0.5, 0.9], // Trigger when 10% of the element is in the viewport
    }
  );

  // TODO4: COPY THIS Start
  // Target the element to observe
  const element = document.querySelector('#interact-observer');
  observer.observe(element);

  document.addEventListener('DOMContentLoaded', function () {
    const checkInterval = 100; // Check every 100 milliseconds
    const timeout = 1000; // Stop checking after 1000 milliseconds (1 second)
    let elapsedTime = 0;

    const intervalId = setInterval(() => {
      const hasVariantsFromApp = document.querySelector('.ymq-options-box');
      const productJsonElement = document.querySelector('[data-product-json]');
      let hasProductVariants = false;

      if (productJsonElement) {
        const product = JSON.parse(productJsonElement.textContent);
        hasProductVariants = product.variants && product.variants.length > 1;
      }

      if ((hasVariantsFromApp || hasProductVariants) || elapsedTime >= timeout) {
        clearInterval(intervalId); // Stop checking

        const lmaSubmitHolders = document.querySelectorAll('#lma__submit__holder');
        lmaSubmitHolders.forEach((lmaSubmitHolder) => {
          if (hasVariantsFromApp || hasProductVariants) {
            lmaSubmitHolder.classList.add('lma_has_variant');            
          } else {
            lmaSubmitHolder.classList.add('lma_has_no_variant');
            lmaSubmitHolder.classList.add('variant_enabled');
          }
        });
      }

      elapsedTime += checkInterval;
    }, checkInterval);
  });
  // TODO4: COPY THIS End